import { axios } from '@/plugins/vueaxios'

export default class InvoiceService {
  public static fetchInvoiceExample(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get('/v4/site/economy/invoices/ocr/settings/example', { params: data })
        .then((response) => resolve(response))
        .catch(error => {
          const backendError = error.response?.data?.error?.message;
          reject(backendError || error);
        });
    })
  }

  public static getInvoiceOcrSettings(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get('/v4/site/economy/invoices/ocr/settings')
        .then((response) => resolve(response.data))
        .catch(error => {
          const backendError = error.response?.data?.error?.message;
          reject(backendError || error);
        });
    })
  }

  public static saveInvoiceOcrSettings(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .put('/v4/site/economy/invoices/ocr/settings', data)
        .then((response) => resolve(response.data))
        .catch(error => {
          const backendError = error.response?.data?.error?.message;
          reject(backendError || error);
        });
    })
  }
}